import { useState, useEffect, useCallback } from "react";
import { getMetrics } from "../../../../services/platform_admin_service";

const usePlatformDashboard = () => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchMetrics = useCallback(async () => {
        try {
            setLoading(true);
            setError(null);
            const result = await getMetrics();
            
            // Mapeia o payload cru da Cloud Function para a estrutura esperada pela tela
            const tenants = result?.tenants || {};
            const billing = result?.billing || {};
            
            // Calcula o MRR total somando os valores de faturamento por plano em billing.mrrByPlan
            const mrrByPlan = billing.mrrByPlan || {};
            const totalMrr = Object.values(mrrByPlan).reduce((acc, val) => acc + (val || 0), 0);
            
            // Traduz a distribuição de planos reais dos tenants
            const planNames = {
                neo: "Neo",
                pro: "Profissional",
                master: "Master",
                basic: "Básico",
                personal: "Pessoal",
                unknown: "Outros"
            };
            const planColors = {
                neo: "#e2661c",
                pro: "#482712",
                master: "#784b22",
                basic: "#85583b",
                personal: "#8b5cf6",
                unknown: "#6b7280"
            };
            
            const planDistribution = tenants.byPlan ? Object.entries(tenants.byPlan).map(([name, count]) => ({
                name: planNames[name] || (name.charAt(0).toUpperCase() + name.slice(1)),
                value: count,
                color: planColors[name] || "#6b7280"
            })) : [];
            
            // Traduz o histórico mensal de aquisição de clientes
            const clientAcquisition = tenants.monthlyAcquisition ? Object.entries(tenants.monthlyAcquisition)
                .sort((a, b) => a[0].localeCompare(b[0]))
                .map(([yearMonth, count]) => {
                    const [year, month] = yearMonth.split("-");
                    const monthsNames = ["JAN", "FEV", "MAR", "ABR", "MAI", "JUN", "JUL", "AGO", "SET", "OUT", "NOV", "DEZ"];
                    const monthIndex = parseInt(month, 10) - 1;
                    const monthLabel = monthsNames[monthIndex] || month;
                    const yearShort = year.slice(-2);
                    return {
                        month: `${monthLabel}/${yearShort}`,
                        newClients: count,
                        cancelledClients: 0
                    };
                }) : [];

            // Constrói o histórico de MRR com os dados reais
            const mrrHistory = totalMrr > 0 ? [
                { month: "ATUAL", mrr: totalMrr }
            ] : [];

            const mappedData = {
                mrr: totalMrr,
                arr: totalMrr * 12,
                revenueReceived: billing.revenueApproved || 0,
                revenuePending: 0,
                activeClients: tenants.active || 0,
                trialClients: tenants.trial || 0,
                inadimplentClients: tenants.blocked || 0,
                cancelledClients: 0,
                churnRate: "0.0%",
                planDistribution,
                clientAcquisition,
                mrrHistory
            };

            setData(mappedData);
        } catch (err) {
            console.error("[usePlatformDashboard]", err);
            setError(err.message || "Erro ao carregar métricas.");
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchMetrics();
    }, [fetchMetrics]);

    return { data, loading, error, refetch: fetchMetrics };
};

export default usePlatformDashboard;
